import React, { useState } from 'react';

// ── Material type icons ────────────────────────────────────────────────────
const MATERIAL_TYPE_ICONS = {
  billboard: (
    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
    </svg>
  ),
  flyer: (
    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
    </svg>
  ),
  brochure: (
    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
    </svg>
  ),
  poster: (
    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
    </svg>
  ),
  standee: (
    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
    </svg>
  ),
  banner: (
    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M3 21v-8a2 2 0 012-2h14a2 2 0 012 2v8M3 21h18" />
    </svg>
  ),
  hoarding: (
    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
    </svg>
  ),
  print: (
    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" />
    </svg>
  ),
};

// ── Skeleton loader for in-progress cards ─────────────────────────────────
const MaterialSkeleton = ({ type, isDarkMode }) => {
  const icon = MATERIAL_TYPE_ICONS[(type || 'print').toLowerCase()] || MATERIAL_TYPE_ICONS.print;
  return (
    <div className={`rounded-2xl border overflow-hidden animate-pulse ${
      isDarkMode ? 'border-gray-700 bg-gray-900/60' : 'border-gray-200 bg-white'
    }`}>
      {/* Mockup placeholder */}
      <div className={`h-44 flex flex-col items-center justify-center gap-3 relative ${
        isDarkMode ? 'bg-gray-800' : 'bg-gray-100'
      }`}>
        <div className={`w-14 h-14 rounded-2xl flex items-center justify-center ${
          isDarkMode ? 'bg-gray-700 text-gray-500' : 'bg-gray-200 text-gray-400'
        }`}>
          {icon}
        </div>
        <div className="flex items-center gap-2">
          <div className="w-2 h-2 bg-amber-400 rounded-full animate-bounce" style={{ animationDelay: '0ms' }} />
          <div className="w-2 h-2 bg-amber-400 rounded-full animate-bounce" style={{ animationDelay: '150ms' }} />
          <div className="w-2 h-2 bg-amber-400 rounded-full animate-bounce" style={{ animationDelay: '300ms' }} />
        </div>
        <p className={`text-xs ${isDarkMode ? 'text-gray-500' : 'text-gray-400'}`}>
          Generating {type}…
        </p>
      </div>
      {/* Content skeleton */}
      <div className="p-4 space-y-2.5">
        <div className={`h-4 rounded-full w-3/4 ${isDarkMode ? 'bg-gray-700' : 'bg-gray-200'}`} />
        <div className={`h-3 rounded-full w-full ${isDarkMode ? 'bg-gray-700' : 'bg-gray-200'}`} />
        <div className={`h-3 rounded-full w-2/3 ${isDarkMode ? 'bg-gray-700' : 'bg-gray-200'}`} />
        <div className="flex gap-2 pt-1">
          <div className={`h-7 rounded-lg flex-1 ${isDarkMode ? 'bg-gray-700' : 'bg-gray-200'}`} />
          <div className={`h-7 w-20 rounded-lg ${isDarkMode ? 'bg-gray-700' : 'bg-gray-200'}`} />
        </div>
      </div>
    </div>
  );
};

// ── Detail Modal ───────────────────────────────────────────────────────────
const MaterialDetailModal = ({ material, isDarkMode, onClose, onApprove, onDownload, onRegenerate }) => {
  if (!material) return null;

  const textPrimary = isDarkMode ? 'text-white' : 'text-gray-900';
  const textSecondary = isDarkMode ? 'text-gray-400' : 'text-gray-500';
  const textMuted = isDarkMode ? 'text-gray-500' : 'text-gray-400';
  const borderColor = isDarkMode ? 'border-gray-700' : 'border-gray-200';
  const cardBg = isDarkMode ? 'bg-gray-800' : 'bg-white';
  const isApproved = material.status === 'approved';

  return (
    <div
      className="fixed inset-0 z-[80] flex items-center justify-center p-4"
      onClick={onClose}
    >
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/70 backdrop-blur-md" />

      {/* Modal panel */}
      <div
        className={`relative w-full max-w-2xl max-h-[90vh] overflow-y-auto rounded-3xl shadow-2xl ${cardBg} ${isDarkMode ? 'border border-gray-700' : 'border border-gray-200'}`}
        onClick={e => e.stopPropagation()}
      >
        {/* Header */}
        <div className={`sticky top-0 z-10 flex items-center justify-between px-6 py-4 border-b ${borderColor} ${cardBg} rounded-t-3xl`}>
          <div className="flex items-center gap-3">
            <div className={`w-9 h-9 rounded-xl flex items-center justify-center ${
              isDarkMode ? 'bg-amber-500/15 text-amber-400' : 'bg-amber-100 text-amber-600'
            }`}>
              {MATERIAL_TYPE_ICONS[(material.type || 'print').toLowerCase()] || MATERIAL_TYPE_ICONS.print}
            </div>
            <div>
              <h3 className={`text-base font-bold ${textPrimary}`}>{material.headline}</h3>
              <p className={`text-xs ${textMuted} capitalize`}>{material.type} • {material.dimensions}</p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            {isApproved && (
              <span className="text-xs font-bold px-3 py-1 rounded-full bg-green-500 text-white shadow-sm">
                ✓ Approved
              </span>
            )}
            <button
              onClick={onClose}
              className={`w-8 h-8 rounded-full flex items-center justify-center transition-all active:scale-90 ${
                isDarkMode ? 'text-gray-400 hover:text-white hover:bg-gray-700' : 'text-gray-400 hover:text-gray-700 hover:bg-gray-100'
              }`}
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2.5">
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>

        {/* Body */}
        <div className="px-6 py-5 space-y-5">
          {/* Mockup / image */}
          <div className={`w-full rounded-2xl overflow-hidden relative ${isDarkMode ? 'bg-gray-900' : 'bg-gray-100'}`} style={{ minHeight: 280 }}>
            {material.generatedAssets?.designMockup || material.imageUrl ? (
              <img
                src={material.generatedAssets?.designMockup || material.imageUrl}
                alt={material.headline}
                className="w-full object-contain rounded-2xl"
                style={{ maxHeight: 400 }}
              />
            ) : (
              <div className="flex flex-col items-center justify-center gap-3 py-16">
                <div className={`w-16 h-16 rounded-2xl flex items-center justify-center ${isDarkMode ? 'bg-gray-800 text-gray-500' : 'bg-gray-200 text-gray-400'}`}>
                  {MATERIAL_TYPE_ICONS[(material.type || 'print').toLowerCase()] || MATERIAL_TYPE_ICONS.print}
                </div>
                <p className={`text-sm ${textSecondary}`}>Design mockup will appear here after approval</p>
              </div>
            )}
          </div>

          {/* Spec tags */}
          <div className="flex flex-wrap gap-2">
            {[
              material.dimensions && `📐 ${material.dimensions}`,
              material.location && `📍 ${material.location}`,
              material.brandPillar && `🎯 ${material.brandPillar}`,
              material.quantity && `🔢 Qty: ${material.quantity}`,
              material.finish && `✨ ${material.finish}`,
            ].filter(Boolean).map((tag, i) => (
              <span key={i} className={`text-xs px-3 py-1.5 rounded-full font-medium border ${
                isDarkMode ? 'border-gray-700 bg-gray-700/50 text-gray-300' : 'border-gray-200 bg-gray-50 text-gray-600'
              }`}>
                {tag}
              </span>
            ))}
          </div>

          {/* Copy sections */}
          {[
            { label: 'Headline', value: material.headline },
            { label: 'Subheadline', value: material.subheadline },
            { label: 'Body Copy', value: material.bodyCopy },
            { label: 'Call to Action', value: material.cta },
          ].filter(x => x.value).map(({ label, value }) => (
            <div key={label}>
              <p className={`text-xs font-bold uppercase tracking-wider mb-1.5 ${textMuted}`}>{label}</p>
              <p className={`text-sm leading-relaxed ${textPrimary}`}>{value}</p>
            </div>
          ))}

          {/* Visual description */}
          {material.visualDescription && (
            <div className={`p-4 rounded-xl border ${isDarkMode ? 'bg-gray-900/60 border-gray-700' : 'bg-gray-50 border-gray-200'}`}>
              <p className={`text-xs font-bold uppercase tracking-wider mb-1.5 ${textMuted}`}>Visual Brief</p>
              <p className={`text-sm leading-relaxed italic ${textSecondary}`}>"{material.visualDescription}"</p>
            </div>
          )}

          {/* Brand colors */}
          {material.brandColors && Array.isArray(material.brandColors) && material.brandColors.length > 0 && (
            <div>
              <p className={`text-xs font-bold uppercase tracking-wider mb-2 ${textMuted}`}>Brand Colors</p>
              <div className="flex gap-2">
                {material.brandColors.map((color, i) => (
                  <div key={i} className="flex flex-col items-center gap-1">
                    <div className="w-8 h-8 rounded-lg border border-black/10 shadow-sm" style={{ backgroundColor: color }} />
                    <span className={`text-[10px] font-mono ${textMuted}`}>{color}</span>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Placement / distribution */}
          {material.placementNotes && (
            <div>
              <p className={`text-xs font-bold uppercase tracking-wider mb-1.5 ${textMuted}`}>Placement Notes</p>
              <p className={`text-sm leading-relaxed ${textSecondary}`}>{material.placementNotes}</p>
            </div>
          )}
        </div>

        {/* Footer actions */}
        <div className={`sticky bottom-0 px-6 py-4 border-t ${borderColor} ${cardBg} rounded-b-3xl flex gap-3`}>
          {!isApproved ? (
            <button
              onClick={() => { onApprove(material.id); onClose(); }}
              className="flex-1 py-3 rounded-2xl text-white text-sm font-bold transition-all hover:brightness-110 active:scale-[0.98] flex items-center justify-center gap-2 shadow-lg"
              style={{ background: 'linear-gradient(135deg, #f59e0b, #ea580c)' }}
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M5 13l4 4L19 7" />
              </svg>
              Approve Material
            </button>
          ) : (
            <>
              <button
                onClick={() => onDownload(material.id, 'pdf')}
                className={`flex-1 py-3 rounded-2xl text-sm font-bold transition-all hover:brightness-110 active:scale-[0.98] flex items-center justify-center gap-2 ${
                  isDarkMode ? 'bg-gray-700 text-gray-200 hover:bg-gray-600' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                </svg>
                Download PDF
              </button>
              <button
                onClick={() => onDownload(material.id, 'png')}
                className={`px-4 py-3 rounded-2xl text-sm font-bold transition-all hover:brightness-110 active:scale-[0.98] flex items-center justify-center gap-2 ${
                  isDarkMode ? 'bg-gray-700 text-gray-200 hover:bg-gray-600' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                PNG
              </button>
            </>
          )}
          <button
            onClick={() => { onRegenerate(material.id); onClose(); }}
            className={`px-4 py-3 rounded-2xl text-sm font-medium transition-all active:scale-[0.98] border ${
              isDarkMode ? 'border-gray-700 text-gray-400 hover:bg-gray-700' : 'border-gray-200 text-gray-500 hover:bg-gray-50'
            }`}
          >
            Regenerate
          </button>
        </div>
      </div>
    </div>
  );
};

// ── Main Component ─────────────────────────────────────────────────────────
const OfflineMarketingPreview = ({
  materials,            // already-generated material objects
  pendingTypes,         // string[] of material types still being generated
  isDarkMode,
  onApprove,
  onDownload,
  onRegenerate,
  onRegenerateAll,
  onBack,
  submitting,
}) => {
  const [detailMaterial, setDetailMaterial] = useState(null);

  const textPrimary = isDarkMode ? 'text-white' : 'text-gray-900';
  const textSecondary = isDarkMode ? 'text-gray-400' : 'text-gray-500';
  const textMuted = isDarkMode ? 'text-gray-500' : 'text-gray-400';
  const bubbleBg = isDarkMode ? 'bg-gray-800' : 'bg-gray-200';

  const totalExpected = materials.length + (pendingTypes?.length || 0);
  const approvedCount = materials.filter(m => m.status === 'approved').length;
  const allApproved = materials.length > 0 && approvedCount === materials.length && (pendingTypes?.length || 0) === 0;
  const isGenerating = (pendingTypes?.length || 0) > 0;
  const isAnyRegenerating = materials.some(m => m.regenerating);

  return (
    <>
      {/* Detail modal */}
      {detailMaterial && (
        <MaterialDetailModal
          material={detailMaterial}
          isDarkMode={isDarkMode}
          onClose={() => setDetailMaterial(null)}
          onApprove={onApprove}
          onDownload={onDownload}
          onRegenerate={onRegenerate}
        />
      )}

      <div className="flex items-start gap-2 mb-4">
        {/* Bot avatar */}
        <div className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 shadow-sm ${
          isDarkMode
            ? 'bg-gradient-to-br from-amber-500/20 to-orange-500/20 border border-amber-500/30'
            : 'bg-gradient-to-br from-amber-100 to-orange-100 border border-amber-300'
        }`}>
          <svg className="w-4 h-4 text-amber-500" fill="currentColor" viewBox="0 0 24 24">
            <path d="M12 0L13.5 8.5L22 10L13.5 11.5L12 20L10.5 11.5L2 10L10.5 8.5L12 0Z" />
          </svg>
        </div>

        <div className="flex-1 min-w-0 max-w-[90%] md:max-w-[80%]">
          {/* Label */}
          <p className={`text-xs font-semibold mb-1.5 ml-1 ${isDarkMode ? 'text-amber-400' : 'text-amber-600'}`}>
            📦 Offline Marketing Materials
          </p>

          <div className={`px-4 py-4 rounded-2xl shadow-sm ${bubbleBg} ${isDarkMode ? 'border border-gray-700/50' : ''}`}>
            {/* Header row */}
            <div className="flex items-center justify-between mb-4">
              <div>
                <h4 className={`text-sm font-bold ${textPrimary}`}>Material Preview</h4>
                <p className={`text-xs ${textMuted} mt-0.5`}>
                  {isGenerating
                    ? `Generating ${pendingTypes.length} more material${pendingTypes.length > 1 ? 's' : ''}…`
                    : `${materials.length} material${materials.length !== 1 ? 's' : ''} ready. Click any card to preview.`
                  }
                </p>
              </div>
              <div className="flex items-center gap-2">
                {/* Live progress pill */}
                {isGenerating && (
                  <span className="text-xs font-semibold px-2.5 py-1 rounded-full bg-amber-500/20 text-amber-500 flex items-center gap-1.5 animate-pulse">
                    <svg className="w-3 h-3 animate-spin" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"/>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"/>
                    </svg>
                    Generating…
                  </span>
                )}
                <span className={`text-xs font-semibold px-2.5 py-1 rounded-full ${
                  allApproved
                    ? 'bg-green-500/20 text-green-500'
                    : isDarkMode ? 'bg-yellow-500/20 text-yellow-400' : 'bg-yellow-100 text-yellow-700'
                }`}>
                  {allApproved ? '✓ All Approved' : `${approvedCount}/${totalExpected} Approved`}
                </span>
              </div>
            </div>

            {/* Progress bar when generating */}
            {isGenerating && (
              <div className="mb-4">
                <div className={`w-full h-1.5 rounded-full overflow-hidden ${isDarkMode ? 'bg-gray-700' : 'bg-gray-200'}`}>
                  <div
                    className="h-full rounded-full transition-all duration-700 ease-out"
                    style={{
                      width: totalExpected > 0 ? `${(materials.length / totalExpected) * 100}%` : '0%',
                      background: 'linear-gradient(90deg, #f59e0b, #ea580c)',
                    }}
                  />
                </div>
                <p className={`text-[10px] mt-1 ${textMuted}`}>
                  {materials.length} of {totalExpected} complete
                </p>
              </div>
            )}

            {/* Grid — completed cards + skeleton placeholders */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-4">
              {/* Completed materials */}
              {materials.map(mat => {
                const type = (mat.type || 'print').toLowerCase();
                const icon = MATERIAL_TYPE_ICONS[type] || MATERIAL_TYPE_ICONS.print;
                const isApproved = mat.status === 'approved';

                return (
                  <div
                    key={mat.id}
                    className={`rounded-2xl border overflow-hidden cursor-pointer transition-all duration-200 group ${
                      isDarkMode ? 'border-gray-700 bg-gray-900/60 hover:border-amber-500/40 hover:shadow-lg hover:shadow-amber-500/10' : 'border-gray-200 bg-white hover:border-amber-400/60 hover:shadow-md'
                    } ${isApproved ? (isDarkMode ? 'ring-1 ring-green-500/30' : 'ring-1 ring-green-400/40') : ''}`}
                    onClick={() => setDetailMaterial(mat)}
                  >
                    {/* Mockup */}
                    <div className={`h-44 flex items-center justify-center relative overflow-hidden ${isDarkMode ? 'bg-gray-800' : 'bg-gray-100'}`}>
                      {mat.generatedAssets?.designMockup || mat.imageUrl ? (
                        <img
                          src={mat.generatedAssets?.designMockup || mat.imageUrl}
                          alt={mat.headline}
                          className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                        />
                      ) : (
                        <div className="flex flex-col items-center gap-2 p-4 text-center">
                          <div className={`w-12 h-12 rounded-xl flex items-center justify-center ${isDarkMode ? 'bg-gray-700 text-gray-400' : 'bg-gray-200 text-gray-500'}`}>
                            {icon}
                          </div>
                          {mat.visualDescription && (
                            <p className={`text-xs italic ${textMuted} line-clamp-2`}>
                              "{mat.visualDescription.substring(0, 80)}…"
                            </p>
                          )}
                        </div>
                      )}

                      {/* Type badge */}
                      <div className="absolute top-2.5 left-2.5">
                        <span className="text-[10px] font-bold px-2 py-1 rounded-full text-white uppercase tracking-wider"
                          style={{ background: 'linear-gradient(135deg, #f59e0b, #ea580c)' }}>
                          {mat.type}
                        </span>
                      </div>
                      {/* Approved badge */}
                      <div className="absolute top-2.5 right-2.5">
                        <span className={`text-[10px] font-bold px-2 py-1 rounded-full uppercase tracking-wider ${
                          isApproved ? 'bg-green-500 text-white' : isDarkMode ? 'bg-gray-700/80 text-gray-400' : 'bg-gray-200/90 text-gray-500'
                        }`}>
                          {isApproved ? '✓ Approved' : 'Draft'}
                        </span>
                      </div>

                      {/* "View details" hover overlay */}
                      <div className={`absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-200 ${isDarkMode ? 'bg-black/50' : 'bg-black/30'}`}>
                        <div className={`flex items-center gap-2 px-4 py-2 rounded-full text-xs font-bold text-white ${isDarkMode ? 'bg-gray-900/80' : 'bg-gray-900/70'} backdrop-blur-sm`}>
                          <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                          </svg>
                          View Details
                        </div>
                      </div>
                    </div>

                    {/* Content */}
                    <div className="p-3 space-y-1.5">
                      <h5 className={`text-sm font-bold ${textPrimary} line-clamp-1`}>{mat.headline}</h5>
                      <p className={`text-xs ${textSecondary} line-clamp-2`}>{mat.bodyCopy}</p>
                      <div className="flex flex-wrap gap-1.5 pt-0.5">
                        {mat.dimensions && (
                          <span className={`text-[10px] px-2 py-0.5 rounded-full font-medium ${isDarkMode ? 'bg-gray-700 text-gray-300' : 'bg-gray-100 text-gray-600'}`}>
                            {mat.dimensions}
                          </span>
                        )}
                        {mat.location && (
                          <span className={`text-[10px] px-2 py-0.5 rounded-full font-medium ${isDarkMode ? 'bg-gray-700 text-gray-300' : 'bg-gray-100 text-gray-600'}`}>
                            📍 {mat.location}
                          </span>
                        )}
                      </div>
                      {/* Quick approve / download row */}
                      <div className="flex gap-2 pt-1" onClick={e => e.stopPropagation()}>
                        {!isApproved ? (
                          <button
                            onClick={() => { if (!isAnyRegenerating) onApprove(mat.id); }}
                            disabled={isAnyRegenerating}
                            className="flex-1 py-1.5 rounded-xl text-xs font-bold text-white transition-all hover:brightness-110 active:scale-95 disabled:opacity-40 disabled:cursor-not-allowed"
                            style={{ background: 'linear-gradient(135deg, #f59e0b, #ea580c)' }}
                          >
                            Approve
                          </button>
                        ) : (
                          <button
                            onClick={() => onDownload(mat.id, 'pdf')}
                            className={`flex-1 py-1.5 rounded-xl text-xs font-bold transition-all hover:brightness-110 active:scale-95 flex items-center justify-center gap-1 ${
                              isDarkMode ? 'bg-gray-700 text-gray-300 hover:bg-gray-600' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                            }`}
                          >
                            <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                            </svg>
                            Download
                          </button>
                        )}
                        <div className="relative group">
                          <button
                            onClick={() => { if (!isAnyRegenerating) onRegenerate(mat.id); }}
                            disabled={isAnyRegenerating}
                            className={`px-2.5 py-1.5 rounded-xl text-xs font-medium transition-colors flex items-center justify-center ${
                              isDarkMode ? 'hover:bg-gray-700 text-gray-400' : 'hover:bg-gray-100 text-gray-500'
                            } disabled:opacity-40 disabled:cursor-not-allowed`}
                          >
                            {mat.regenerating ? (
                              <svg className="w-3.5 h-3.5 animate-spin" fill="none" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
                              </svg>
                            ) : '↺'}
                          </button>
                          <div className="absolute bottom-full right-0 mb-1.5 hidden group-hover:block z-10 pointer-events-none">
                            <div className={`text-xs px-2 py-1 rounded-lg whitespace-nowrap shadow-lg ${
                              isDarkMode ? 'bg-gray-700 text-gray-200' : 'bg-gray-800 text-white'
                            }`}>
                              {mat.regenerating ? 'Regenerating…' : 'Regenerate this material'}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}

              {/* Skeleton placeholders for in-progress materials */}
              {(pendingTypes || []).map(type => (
                <MaterialSkeleton key={`pending-${type}`} type={type} isDarkMode={isDarkMode} />
              ))}
            </div>

            {/* Bulk action buttons */}
            <div className="flex gap-2">
              <button
                onClick={() => materials.filter(m => m.status === 'approved').forEach((m, i) => setTimeout(() => onDownload(m.id, 'pdf'), i * 300))}
                disabled={!allApproved}
                className={`flex-1 py-2.5 rounded-xl text-sm font-bold transition-all duration-200 flex items-center justify-center gap-2 active:scale-[0.98] ${
                  allApproved
                    ? 'text-white hover:shadow-lg hover:shadow-amber-500/25 hover:brightness-110'
                    : 'opacity-40 cursor-not-allowed'
                }`}
                style={allApproved ? { background: 'linear-gradient(135deg, #f59e0b, #ea580c)' } : {
                  background: isDarkMode ? '#374151' : '#e5e7eb',
                  color: isDarkMode ? '#6b7280' : '#9ca3af',
                }}
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                </svg>
                Download All
              </button>
              <button
                onClick={onRegenerateAll}
                disabled={isGenerating || isAnyRegenerating}
                className={`px-4 py-2.5 rounded-xl text-sm font-medium transition-all duration-200 active:scale-[0.98] border flex items-center gap-2 ${
                  isDarkMode ? 'border-gray-600 text-gray-300 hover:bg-gray-700/60 disabled:opacity-40' : 'border-gray-200 text-gray-600 hover:bg-gray-50 disabled:opacity-40'
                }`}
              >
                {isAnyRegenerating ? (
                  <>
                    <svg className="w-3.5 h-3.5 animate-spin" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
                    </svg>
                    Regenerating…
                  </>
                ) : 'Regenerate All'}
              </button>
              <button
                onClick={onBack}
                disabled={isGenerating}
                className={`px-4 py-2.5 rounded-xl text-sm font-medium transition-all duration-200 active:scale-[0.98] border ${
                  isDarkMode ? 'border-gray-600 text-gray-300 hover:bg-gray-700/60 disabled:opacity-40' : 'border-gray-200 text-gray-600 hover:bg-gray-50 disabled:opacity-40'
                }`}
              >
                Back
              </button>
            </div>

            {/* Branding */}
            <div className="flex items-center mt-2 px-1">
              <span className={`text-[10px] ${textMuted}`}>⚡ Powered by Infinium</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OfflineMarketingPreview;